import { UpdateSupplierPayloadInterface } from '../../../../shared/interfaces/survey-meta-data.interface';

export class GroupedSupplierOverride {
  constructor(public readonly payload: UpdateSupplierPayloadInterface) {}

  public cpi(): void {
    this.payload.manualOverrideMdl =
      this.payload.manualOverrideMdl ||
      (!this.payload.operatorOverrideMdl && this.has());
  }

  public has(): boolean {
    return this.payload.suppliers.some((sup) => !!sup.group_name);
  }
}
